<template>
    <div>
        <!-- 搜索 -->
        <search  :search="true" :type="'DepartmentManagement'" @add-data="add_data" @search-data="search_data" @Export="Export"></search>
        <!-- 列表 -->
        <tables id="table-box"  :tableData="tableData"  :tableLabel="tableLabel" :ifheader="false" :Calculate="false" @event-button="event_button" ></tables>
        <!-- 新增部门 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="New_Department" :title="title"  :width="'720px'" v-if="New_Department">
            <NewDepartment :visibles.sync="New_Department" @Render="Render" :type="type" :row="row"></NewDepartment>
        </el-dialog>
         <!-- 分页 -->
        <pagination
            v-show="(Number(total) > 0)"
            :total="Number(total)"
            :page.sync="matterParams.current"
            :limit.sync="matterParams.size"
            @pagination="Render"
        />
    </div>
</template>
<script>
import NewDepartment from '../dialog/NewDepartment'
export default {
  components: {
    NewDepartment
  },
  // props: {
  // '': {
  //    type:Object|Array|String|Boolean|Number
  //  }
  // },
  data () {
    return {
      New_Department: false,
      title: '',
      total: 0,
      type: '',
      row: {},
      matterParams: {
        // 默认显示页数
        current: 1,
        // 一页几条数据
        size: 10,
        orders: 'gmtCreate|desc'
      },
      tableData: [
      ],
      tableLabel: [
        { label: '序号', width: '80', prop: 'index', type: '', align: 'center' },
        { label: '部门名称', width: '', prop: 'name', align: 'center' },
        { label: '所属部门', width: '', prop: 'parentName', type: '', align: 'center' },
        { label: '所属地区', width: '180', prop: 'districtName', type: '', align: 'center' },
        {
          label: '操作',
          width: '',
          isOpera: true, // 判断是否生成按钮
          isbutton: true, // 是否操作按钮
          titleList: [
            {
              title: '新增子级部门',
              status: 'primary',
              controldisabled: true
            },
            { title: '修改', status: 'primary' },
            { title: '删除', status: 'primary' }
          ]
        }
      ]
    }
  },
  methods: {
    // 新增
    add_data (v) {
      this.title = '新增部门'
      this.New_Department = true
      this.type = 'add'
      this.row = {}
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1
      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 导出
    Export () {
    //   this.tableLabel[8].ifshow = true
      setTimeout(() => {
        this.$tableToExcel('#table-box .el-table', '部门信息.xlsx')
        // this.tableLabel[8].ifshow = false
      })
      this.$message.success('导出成功')
    },
    // 列表按钮
    event_button (type, row) {
      if (type === '修改') {
        this.New_Department = true
        this.title = '修改部门'
        this.type = 'edit'
        this.row = row
      } else if (type === '删除') {
        this.$confirm(`此操作将永久删除<span style="color:red"> ${row.name} </span> 该部门, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true // 将dangerouslyUseHTMLString属性设置为 true，message 就会被当作 HTML 片段处理
        }).then(() => {
          this.$http.Delete('/dict/department/deleteDept', { id: row.id }).then((res) => {
            this.$message.success('删除成功')
            this.Render()
          })
        }).catch(() => {})
      } else if (type === '新增子级部门') {
        this.New_Department = true
        this.title = '新增子级部门'
        this.type = 'AddChildren'
        this.row = row
      }
    },
    // 列表数据
    Render () {
      this.$http.get('/dict/department/queryPage', this.matterParams).then((res) => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
      // this.$http.get('/dict/department/queryPageTree', this.matterParams).then((res) => {
      //   this.tableData = res.data.records
      //   this.tableData = res.data.records
      //   this.total = res.data.total
      // })
    }
  },
  created () {
    this.Render()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
    // .main{
    //     display: flex;
    //     height: 800px;
    //     padding: 20px 0px 0 50px;
    //     .right{
    //        background: green;
    //        width: 100%;
    //        height: 100%;
    //     }
    // }
</style>
